import { render, staticRenderFns } from "./ControlPanelView.vue?vue&type=template&id=13b8423e"
import script from "./ControlPanelView.vue?vue&type=script&lang=js"
export * from "./ControlPanelView.vue?vue&type=script&lang=js"
import style0 from "./ControlPanelView.vue?vue&type=style&index=0&id=13b8423e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports